import React, { useState } from 'react';
import { Btn, H6, Image, LI, UL } from '../../../../AbstractElements';
import { Cancel, ConnectNewAccount, OpenFirstModal } from '../../../../Utils/Constants';
import CommonModal from '../Common/CommonModal';
import { dynamicImage } from '../../../../Utils';
import OtherModal from './OtherModal';

// ✅ Define prop types
type ToggleModalBodyProps = {
    onConfirm?: () => void;
    confirmText?: string;
    triggerLabel?: string;
};

export default function ToggleModalBody({
    onConfirm,
    confirmText = 'Are you sure?',
    triggerLabel = 'Repeat The Last Plan',
}: ToggleModalBodyProps) {
    const [open, setOpen] = useState(false);
    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);
    const toggle2 = () => setOpen(!open);

    const data = {
        isOpen: modal,
        center: true,
        toggler: toggle,
    };

    return (
        <>
            {/* Trigger button */}
            <Btn color="dark" onClick={toggle}>{triggerLabel}</Btn>

            {/* Confirmation Modal */}
            <CommonModal modalData={data}>
                <div className="text-center px-3 py-4">
                    <H6 className="mb-3">{confirmText}</H6>

                    <div className="d-flex flex-column gap-2">
                        <Btn
                            color="primary"
                            className="rounded-pill w-100"
                            onClick={() => {
                                if (onConfirm) onConfirm();
                                toggle(); // close modal
                            }}
                        >
                            Confirm
                        </Btn>

                        <Btn
                            color="secondary"
                            className="rounded-pill w-100"
                            type="button"
                            onClick={toggle}
                        >
                            {Cancel}
                        </Btn>
                    </div>
                </div>
            </CommonModal>

            {/* Optional extra modal (existing behavior) */}
            <OtherModal modal={open} toggle={toggle2} />
        </>
    );
}
